import {Store} from '@gongxigames/framework/core';

export const uiElementsStore = Store.createStore({
    sound_btn_disabled: Store.signal(true),
    menu_btn_disabled: Store.signal(true),
    turbo_btn_disabled: Store.signal(true),
    auto_btn_disabled: Store.signal(true),
    home_btn_disabled: Store.signal(true),
    fullscreen_btn_disabled: Store.signal(true),
    bet_panel_disabled: Store.signal(true),
    bet_panel_hidden: Store.signal(false),
});